import React from 'react';
import { UserAgreementModal } from './UserAgreementModal';
import { PRIVACY_POLICY_VERSION, PRIVACY_POLICY_TEXT } from '../config/privacyPolicy';

interface PrivacyPolicyModalProps {
  visible: boolean;
  onClose: () => void;
}

export const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ visible, onClose }) => (
  <UserAgreementModal
    visible={visible}
    onClose={onClose}
    title="Privacy Policy"
    version={PRIVACY_POLICY_VERSION}
    text={PRIVACY_POLICY_TEXT}
  />
);
